<template>
    <div>
        <div class="user_center_header">
            <div class="ring_set">
                <p class="icon ring" :class="{'hasmsg animate__animated animate__tada animate__slow animate__infinite': hasmsg}" @click="gotoMsg">
                    <img src="../../assets/version_1.3.0/usercenter/ring.png" alt="">
                </p>
                <p class="icon set" @click="gotoSetting">
                    <img src="../../assets/version_1.3.0/usercenter/set.png" alt="">
                </p>
            </div>
            <div class="user_top">
                <van-image class="user_icon" :src="require('../../assets/version_1.3.0/usercenter/user_login.png')"
                    v-if="isLogin" />
                <van-image class="user_icon" :src="require('../../assets/version_1.3.0/usercenter/user.png')" v-else
                    @click="gotoLogin" />
                <div class="user_info" @click="gotoLogin">
                    <p class="name" v-if="isLogin">{{ userData.username | plusX}}</p>
                    <p class="name" v-else>点击登录</p>
                    <p class="uid" v-if="isLogin">
                        GID：{{ userData.user_id }}
                    </p>
                    <p class="uid" v-else>登录发现更多精彩</p>
                </div>
                <div class="user_right" @click="gotoWallet">
                    <div class="wallet" v-if="isLogin">
                        <span>我的钱包</span>
                        <img class="icon" src="../../assets/version_1.3.0/usercenter/wallet.png" alt="">
                    </div>
                    <van-icon class="arrow" name="arrow" color="#fff" v-else />
                </div>
            </div>
        </div>
        <div class="user_center_area">
            <!-- 我的交易 -->
            <div class="box_area">
                <div class="title">
                    <div class="title_words">我的交易</div>
                </div>
                <div class="grid">
                    <div class="grid_item" v-for="(item,i) in tradeList" :key="i"
                        @click="gotoTarget(item.path,item.link)">
                        <img class="icon" :src="item.icon" alt="">
                        <div class="word">{{item.name}}</div>
                    </div>
                </div>
            </div>
            <!-- 我的服务 -->
            <div class="box_area service">
                <div class="title">
                    <div class="title_words">我的服务</div>
                </div>
                <div class="grid">
                    <div class="grid_item" v-for="(item,i) in toolList" :key="i"
                        @click="gotoTarget(item.path,item.link)">
                        <img class="icon" :src="item.icon" alt="">
                        <div class="word">{{item.name}}</div>
                    </div>
                </div>
            </div>
        </div>
        <van-popup v-model="showPop" class="lf_pop">
            <div class="tit">提示</div>
            <p>账号当前无法申请注销，建议您先 尝试以下方式：</p>
            <p>1.余额过多，请先提现 </p>
            <p>2.商品出售中，请先下架 </p>
            <p>3.提现未到账，请等候1-2个工作日</p>
            <van-button class="know" @click="showPop = false">知道了</van-button>
        </van-popup>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                tradeList: [{
                        name: '购买记录',
                        icon: require('../../assets/version_1.3.0/usercenter/icon1.png'),
                        path: 'user.buy'
                    },
                    {
                        name: '出售记录',
                        icon: require('../../assets/version_1.3.0/usercenter/icon2.png'),
                        path: 'user.sell'
                    },
                    {
                        name: '我的商品',
                        icon: require('../../assets/version_1.3.0/usercenter/icon3.png'),
                        path: 'user.goods'
                    }
                ],
                toolList: [{
                        name: '实名认证',
                        icon: require('../../assets/version_1.3.0/usercenter/icon5.png'),
                        path: 'user.identity'
                    },
                    {
                        name: '角色绑定',
                        icon: require('../../assets/version_1.3.0/usercenter/icon6.png'),
                        path: 'user.bind'
                    },
                    {
                        name: '帮助中心',
                        icon: require('../../assets/version_1.3.0/usercenter/icon7.png'),
                        path: 'user.faq'
                    },
                    {
                        name: '支付密码',
                        icon: require('../../assets/version_1.3.0/usercenter/icon8.png'),
                        path: 'user.password'
                    },
                    {
                        name: '联系客服',
                        icon: require('../../assets/version_1.3.0/usercenter/icon9.png'),
                        link: 'kefu'
                    },
                    {
                        name: '账号注销',
                        icon: require('../../assets/version_1.3.0/usercenter/icon10.png'),
                        link: 'logoff'
                    },
                    {
                        name: '交易管家',
                        icon: require('../../assets/version_1.3.0/usercenter/icon12.png'),
                        path: 'user.butler'
                    }
                ],
                showPop: false,

                hasmsg: false, //消息中心有消息
                timer: null, //轮询的timer
            }
        },
        filters: {
            plusX(str) {
                var x = "*******";
                if (str) {
                    if (str.length >= 6) {
                        return (
                            str.substring(0, 3) + x + str.substring(str.length - 1, str.length)
                        );
                    } else {
                        return str;
                    }
                }
            },
        },
        computed: {
            userData() {
                return this.$store.getters.state.userData || {};
            },
            isLogin() {
                return this.$store.getters.isLogin;
            },
        },
        mounted() {
            // if (this.isLogin) {
            //     this.$store.dispatch("getUserData", true);
            // }
        },
        methods: {
            gotarget(path, link) {
                if (path != '') {
                    if (path == 'user.notice') {
                        this.$router.push({
                            name: path,
                            query: {
                                active: 0
                            }
                        })
                    } else if (path == 'user.sell') {
                        window.location.href = '/user/sell/0'
                        // this.$router.push({
                        //     name: path,
                        //     params: {
                        //         status: 0
                        //     }
                        // })
                    } else if (path == 'user.buy') {
                        window.location.href = '/user/buy/0'
                        // this.$router.push({
                        //     name: path,
                        //     params: {
                        //         status: 0
                        //     }
                        // })
                    } else if (path == 'user.goods') {
                        // window.location.href = '/user/mygoods/0'
                        this.$router.push({
                            name: path,
                            params: {
                                status: 0
                            }
                        })
                    } else if (path == 'user.identity') {
                        this.$router.push({
                            name: path,
                            query: {
                                redirect: this.$route.fullPath
                            }
                        })
                    } else {
                        this.$router.push({
                            name: path
                        })
                    }
                }
                if (link == 'kefu') {
                    window.location.href =
                        'https://livechathuyu.gmmsj.com/index/index/kefu?u=6265f471b483e&platform=8&game_id=8889&game_name=G买卖&uid=8_' +
                        this.userData.user_id + '&phone=' + this.userData.username
                }
                if (link == 'logoff') {
                    this.$Ajax('login-out/check-login-out', {}, 'get').then(rs => {
                        if (rs.code == 407) {
                            this.showPop = true
                        } else if (rs.code == 200) {
                            this.$router.push({
                                name: 'user.logoff'
                            })
                        } else {
                            this.$Message.error(rs.msg)
                        }
                    })
                }
            },
            // 前往 我的交易 工具与服务 对应目标地址
            gotoTarget(path, link) {
                if (!this.isLogin) {
                    this.$filterPop({
                        type: 'login',
                        direction: 'up',
                        onSuccess: () => {
                            this.gotarget(path, link)
                        }
                    })
                } else {
                    this.gotarget(path, link)
                }
            },
            gotoLogin() {
                if (!this.isLogin) {
                    this.$filterPop({
                        type: 'login',
                        direction: 'up',
                        onSuccess: () => {
                            this.$store.dispatch("getUserData", true);
                        }
                    })
                }
            },
            gotoWallet() {
                if (!this.isLogin) {
                    this.$filterPop({
                        type: 'login',
                        direction: 'up',
                        onSuccess: () => {
                            this.$router.push({
                                name: 'user.wallet'
                            })
                        }
                    })
                } else {
                    this.$router.push({
                        name: 'user.wallet'
                    })
                }
            },
            gotoSetting() {
                if (!this.isLogin) {
                    this.$filterPop({
                        type: 'login',
                        direction: 'up',
                        onSuccess: () => {
                            this.$router.push({
                                name: 'user.setting'
                            })
                        }
                    })
                } else {
                    this.$router.push({
                        name: 'user.setting'
                    })
                }
            },
            gotoMsg() {
                if (this.isLogin) {
                    this.$Ajax('index/last-click')
                    this.$router.push({
                        name: 'user.msg'
                    })
                } else {
                    this.$filterPop({
                        type: "login",
                        direction: 'up',
                        onSuccess: () => {
                            this.$Ajax('index/last-click')
                            this.$router.push({
                                name: 'user.msg'
                            })
                        }
                    });
                }
            },
            //轮询
            settimeout() {
                this.getMsg();
                this.timer = window.setInterval(() => {
                    setTimeout(() => {
                        this.getMsg();
                    }, 0);
                }, 10000);
            },
            getMsg() {
                this.$Ajax('index/check-redpoint', {}, 'get').then(rs => {
                    if (rs.code == 200) {
                        if (Number(rs.data.count) > 0) {
                            this.hasmsg = true
                        } else {
                            this.hasmsg = false
                        }
                    }
                })
            },
        },
        watch: {
            isLogin: {
                immediate:true,
                handler(e) {
                    if(e) {
                        this.settimeout()
                    }else {
                        clearInterval(this.timer);
                    }
                }
            }
        },
        beforeRouteLeave (to, from, next) {
          next()
          if(this.timer) {
            clearInterval(this.timer);
            this.timer = null
          }
        }
    }
</script>

<style lang="less" scoped>
    .user_center_header {
        position: fixed;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        max-width: 525px;
        height: 22.5rem;
        background: url(../../assets/version_1.3.0/index/linear.png) no-repeat 0 -3.7rem / 100% 26.2rem;
        z-index: 1;
        padding: 1rem;

        .ring_set {
            display: flex;
            justify-content: flex-end;
            align-items: flex-start;
            height: 3.2rem;

            .icon {
                height: 2rem;
                margin-left: 1.5rem;
                cursor: pointer;

                &.ring {
                    width: 1.6rem;
                    &.hasmsg {
                        position: relative;
                        &::after {
                          position: absolute;
                          right: 0;
                          top: 0;
                          content: '';
                          width: .7rem;
                          height: .7rem;
                          background-color: var(--red);
                          border-radius: 50%;
                        }
                    }
                }

                &.set {
                    width: 2.1rem;
                }

                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        .user_top {
            display: flex;
            align-items: center;

            .user_icon {
                width: 5.7rem;
                height: 5.7rem;
                border-radius: 50%;
                overflow: hidden;
                margin-right: 1.4rem;
            }

            .user_info {
                flex: 1;
                padding-top: .35rem;
                color: #fff;
                font-family: Source Han Sans CN, Source Han Sans CN;

                .name {
                    font-size: 1.8rem;
                    font-weight: 700;
                    margin-bottom: .5rem;
                }

                .uid {
                    font-size: 1.2rem;
                }
            }

            .user_right {
                width: 8.2rem;
                display: flex;
                align-items: center;
                justify-content: flex-end;

                .wallet {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    font-size: 1.2rem;
                    color: #fff;
                    padding-right: 1rem;
                    cursor: pointer;
                    .icon {
                        width: 1.8rem;
                        height: 1.8rem;
                    }
                }

                .arrow {
                    font-size: 1.2rem;
                }
            }
        }
    }

    .user_center_area {
        position: absolute;
        width: 100%;
        z-index: 2;
        margin-top: 11rem;
    }

    .box_area {
        padding: 1rem 0 0;
        margin: 0 1rem 1rem;
        background-color: #fff;
        border-radius: 0.5rem;
        overflow: hidden;

        .grid {
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            padding: 0 1rem;

            .grid_item {
                padding: 0;
                width: calc(1/4*100%);
                display: flex;
                flex-direction: column;
                align-items: center;
                cursor: pointer;
                margin-bottom: 2.6rem;

                .icon {
                    width: 3.4rem;
                    height: 2.4rem;
                    margin-bottom: .4rem;
                }

                .word {
                    font-size: 1.2rem;
                    color: #606060;
                }

                &:hover {

                    .icon,
                    .word {
                        color: var(--theme);
                    }
                }

                &.not_use {

                    .icon,
                    .word {
                        color: #bbb;
                    }
                }

                &:nth-child(9) {
                    .icon {
                        width: auto;
                        height: 2.35rem;
                    }
                }
            }
        }

        .title {
            display: flex;
            align-items: center;
            padding: 0 1rem;
            margin-bottom: 1.8rem;

            .title_words {
                font-size: 1.6rem;
                font-weight: 700;
                font-family: Source Han Sans CN, Source Han Sans CN;
            }
        }
    }

    .service {
        padding-bottom: 0;

        .grid_item:nth-child(7) {
            .icon {
                width: 2.4rem;
            }
        }

    }

    .lf_pop {
        width: 26rem;
        height: 23.2rem;
        background-color: #fff;
        border-radius: 1.5rem;
        padding: 0 2.3rem;

        .tit {
            margin-top: 2rem;
            font-size: 1.6rem;
            font-weight: 700;
            color: #FE6455;
            text-align: center;
            margin-bottom: 1.4rem;
        }

        p {
            word-break: break-all;
            color: #555;
            font-size: 1.4rem;
            line-height: 1.5;
        }

        .know {
            width: 22rem;
            height: 3.2rem;
            background: #FE6455;
            border-radius: 1.6rem;
            color: #fff;
            font-size: 1.6rem;
            margin-top: 2rem;
        }
    }
</style>